/* eslint-disable import/no-cycle */
import { getI18nLanguage } from '@/plugins/i18n'
import { apiHttp } from '../axiosApi'
import { publicWaiver } from '../config/apiRoute'

const publicHeaders = () => ({
  Accept: 'application/json',
  'Accept-Language': getI18nLanguage(),
})

/** Todo lo que la pagina /w/:token necesita (club, reserva, roster con quien
 *  ya firmo, documento EN/ES). 404 token inexistente, 410 vencido. */
export const getPublicWaiver = async token => apiHttp(
  'GET',
  `${publicWaiver}${token}`,
  {},
  { headers: publicHeaders() },
  true,
  'v3',
)

/** Firma dibujada. `form` es un FormData: full_name, phone_code, phone_number,
 *  email, marketing_consent, lang, signature_png (Blob), player_match_id?, op? */
export const signPublicWaiver = async (token, form) => apiHttp(
  'POST',
  `${publicWaiver}${token}/sign`,
  form,
  { headers: { ...publicHeaders(), 'Content-Type': 'multipart/form-data' } },
  true,
  'v3',
)
